import { Box } from "@noom/wax-component-library";
import DOMPurify from "dompurify";
import { type ReactNode } from "react";

export const sanitizeProgramNameHtml = (html: string): string =>
  DOMPurify.sanitize(html, {
    ALLOWED_TAGS: ["sup"],
    ALLOWED_ATTR: [],
  });

/**
 * Renders the catalog's display-ready program name. Only intentional <sup>
 * markup survives sanitization; all attributes and other tags are removed.
 */
export const renderProgramName = (programName: string): ReactNode => (
  <Box
    as="span"
    sx={{ "& sup": { textTransform: "none" } }}
    dangerouslySetInnerHTML={{
      __html: sanitizeProgramNameHtml(programName),
    }}
  />
);
